/*
 * (c) Copyright Reserved EVRYTHNG Limited 2021. All rights reserved.
 * Use of this material is subject to license.
 * Copying and unauthorised use of this material strictly prohibited.
 */

import { useEffect, useState } from '../_snowpack/pkg/react.js';
import { getCookie, removeCookie, setCookie } from './cookiesUtils.js';

/**
 * @param {boolean} areCookiesAllowed
 * @param {string} name
 * @param {any} defaultValue
 * @returns {[any, function()]}
 */
export default function useCookieState(areCookiesAllowed, name, defaultValue) {
  const [state, setState] = useState(getCookie(name) ?? defaultValue);

  useEffect(() => {
    if (areCookiesAllowed && state) setCookie(name, state);
    else removeCookie(name);
  }, [areCookiesAllowed, state]);

  return [state, setState];
}
